import { toSnakeCase } from '@src/utils/convertToSnakeCase';

export const pushToDataLayer = (data: any) => {
	const formattedData = toSnakeCase(data);

	if (typeof window !== 'undefined') {
		if (!window.dataLayer) {
			// @ts-ignore
			window.dataLayer = [];
		}
		window.dataLayer.push(formattedData);
	} else {
		console.warn('window is not defined.');
	}
};
